import serviceBase from "./serviceBase";
import { EndPoint } from "../appConfig";
import Cache from "../cache";

const cache = new Cache();

var RoomAttributeService = Object.create(
  new serviceBase(EndPoint.RoomAttribute)
);

/**
 * 登録されている、会議室を取得します。
 */
RoomAttributeService.getRoomAttributes = function(forced) {
  var self = this;
  if (!forced && cache.attributes) return Promise.resolve(cache.attributes);
  return new Promise((resolve) => {
    self.get().then(attributes => {
      cache.attributes = attributes;
      resolve(attributes);
    });
  });
};
export default RoomAttributeService;
